<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto py-5 text-left" style="max-width: 1460px">
        <b-col sm="12">
          <h1 class="text-white"><b>Istuzioni per le Organizzazioni</b></h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col lg="12" class="text-left">
        <p>
          Per accedere alla piattaforma occorre registrarsi compilando l’apposito modulo e seguendo la procedura di
          registrazione per e-mail.
        </p>
        <p>
          In corrispondenza dell’Organizzazione inserisci un nome univoco, utilizzato di norma all’interno della tua
          organizzazione in modo che ciascun operatore scelga il medesimo nome.
        </p>
        <p>Una volta accreditato puoi caricare il file.</p>
        <p>
          Deve trattarsi di file brevi, preferibilmente in word o formati analoghi oppure, eccezionalmente, in pdf e
          jpeg. Se redatti in prima persona, i testi devono essere semplici e di facile comprensione.
        </p>
        <p>Evita quanto più possibile la presenza di dati personali e di altri dati sensibili nei contenuti.</p>
        <p>
          Compila tutti i campi obbligatori, selezionando la lingua o le lingue in cui il documento deve essere tradotto
          e indicando la data di consegna desiderata.
        </p>
        <p>
          Una volta che la traduzione è stata spedita dal traduttore, la troverai nell’apposito elenco (“Richieste in
          corso”). L’elenco è disposto per ordine cronologico.
        </p>

        <hr />

        <h3>COSA FARE IN CASO DI MALFUNZIONAMENTO TECNICO</h3>
        <p>
          Puoi segnalare eventuali bug scrivendo a help@languageaid.org, avendo cura di specificare in modo quanto più
          preciso possibile il tipo di disservizio riscontrato e le circostanze in cui si è verificato (indica
          chiaramente l’indirizzo della pagina in cui si è verificato il malfunzionamento e fai uno screenshot mettendo
          in evidenza l’errore).
        </p>

        <h3>COSA FARE IN CASO DI SMARRIMENTO DELLA PASSWORD</h3>
        <p>
          E' buona norma usare password sicure (es. combinazioni di parole, caratteri speciali e cifre) che possano
          essere ricordate facilmente.
        </p>

        <p>
          Tuttavia, nella malaugurata eventualità in cui dovessi non ricordare la tua password, scrivici brevemente a
          help@languageaid.org. Provvederemo a resettare la tua password e inviare all’indirizzo e-mail indicato una
          nuova mail di conferma per impostarne una nuova.
        </p>

        <h3>COSA FARE IN CASO UN’ALTRA ORGANIZZAZIONE CHE CONOSCI FOSSE INTERESSATA A LANGUAGE AID</h3>
        <p>
          La piattaforma è studiata per essere un supporto libero e gratuito per tutte le organizzazioni; tuttavia, ti
          chiediamo di invitare l’organizzazione a segnalarci il suo interesse via mail (all’indirizzo
          info@languageaid.org) prima di effettuare la registrazione autonomamente.
        </p>

        <h3>MIGLIORIAMO INSIEME</h3>
        <p>
          Vi ricordiamo inoltre che potete segnalarci i vostri suggerimenti e desiderata per rendere sempre più
          efficiente la piattaforma.
        </p>

        <b>CONTATTI:</b> <a href="mailto:info@languageaid.org">info@languageaid.org</a><br />
        <b>ASSISTENZA:</b> <a href="help@languageaid.org">help@languageaid.org</a><br />
        <hr class="btn-outline-primary" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
  background-position-y: 80%;
}
</style>
